import { Check, Loader2, RefreshCw, X } from 'lucide-react';

/**
 * Nút kiểm tra proxy của một thành viên.
 *
 * Tách ra vì nó mang cả BỘ MÀU theo trạng thái — thứ dài hơn hẳn phần logic —
 * và `GroupConfigModal` thì chỉ cần biết "đang ở trạng thái nào, bấm thì gọi ai".
 */

export type ProxyHealth = 'idle' | 'checking' | 'alive' | 'dead';

const PROXY_CHECK_STYLES: Record<ProxyHealth, string> = {
  idle: 'border-line text-ink-muted hover:bg-panel-hover',
  checking: 'border-line text-ink-muted',
  alive: 'border-success-border bg-success-bg text-success',
  dead: 'border-danger-border bg-danger-bg text-danger',
};

interface ProxyCheckButtonProps {
  state: ProxyHealth;
  disabled: boolean;
  onClick: () => void;
}

/** Nút thử proxy — kết quả nằm ngay trên nút thay vì chỉ toast rồi biến mất. */
export function ProxyCheckButton({ state, disabled, onClick }: ProxyCheckButtonProps) {
  const icon = {
    idle: <RefreshCw size={13} />,
    checking: <Loader2 size={13} className="animate-spin" />,
    alive: <Check size={13} />,
    dead: <X size={13} />,
  }[state];

  const label = { idle: 'Check', checking: 'Đang thử', alive: 'Sống', dead: 'Chết' }[state];

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || state === 'checking'}
      className={`flex shrink-0 items-center gap-1.5 rounded-lg border px-3 py-2 text-[12px] font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-40 ${PROXY_CHECK_STYLES[state]}`}
    >
      {icon}
      {label}
    </button>
  );
}

